import {
  Component,
  Host,
  h,
  Element,
  Prop,
  Watch,
  Listen,
} from "@stencil/core";

import {
  StzhBannerCloseEvent,
  StzhGhettoboxCloseEvent,
  StzhMessageCloseEvent
} from "../../index";

import Cookie from "js-cookie";

const KEY_PREFIX_CLOSE = "stzh-components-show-close";

/**
 * @slot - Slot for any content
 */
@Component({
  tag: "stzh-show",
  styleUrl: "stzh-show.scss",
  shadow: true
})
export class StzhShow {
  /** Mikro */
  @Prop({ reflect: true }) mikro: boolean;

  /** Small */
  @Prop({ reflect: true }) small: boolean;

  /** Medium */
  @Prop({ reflect: true }) medium: boolean;

  /** Large */
  @Prop({ reflect: true }) large: boolean;

  /** Ultra */
  @Prop({ reflect: true }) ultra: boolean;

  /** Show from date */
  @Prop() showFromDate: Date | string;
  private _showFromDate: Date;

  /** Hide from date */
  @Prop() hideFromDate: Date | string;
  private _hideFromDate: Date;

  /**
   * Close cookie name key.
   * Component will check for the cookie (stzh-components-show-close-{name})
   * and if not empty (component inside already closed before) will hide show.
   * Will also compare with showFromDate if given, to make sure cookie was set after showFromDate (otherwise will show again).
   */
  @Prop() closeKey: string = "";

  @Listen("stzhClose")
  closeWatcher(event: CustomEvent<StzhBannerCloseEvent | StzhMessageCloseEvent | StzhGhettoboxCloseEvent>) {
    if (["stzh-banner", "stzh-message", "stzh-ghettobox"].includes(event.detail.component)) {
      if (this.closeKey) {
        Cookie.set(`${KEY_PREFIX_CLOSE}-${this.closeKey}`, Date.now().toString());
      }
    }
  }

  @Watch("showFromDate")
  showFromDateWatcher(newValue: Date | string) {
    if (typeof newValue === "string") {
      this._showFromDate = newValue ? new Date(newValue) : null;
    } else {
      this._showFromDate = newValue;
    }

    let closedByCookie = false;

    if (this.closeKey) {
      const timeClosed = Cookie.get(`${KEY_PREFIX_CLOSE}-${this.closeKey}`);

      if (
        timeClosed && (
          !this._showFromDate
          || Number(timeClosed) >= this._showFromDate.getTime()
        )
      ) {
        closedByCookie = true;
      }
    }

    this.closedByCookie = closedByCookie;
  }

  @Watch("hideFromDate")
  hideFromDateWatcher(newValue: Date | string) {
    if (typeof newValue === "string") {
      this._hideFromDate = newValue ? new Date(newValue) : null;
    } else {
      this._hideFromDate = newValue;
    }
  }

  @Element() element: HTMLStzhShowElement;

  private closedByCookie: boolean = false;

  componentWillLoad() {
    this.showFromDateWatcher(this.showFromDate);
    this.hideFromDateWatcher(this.hideFromDate);
  }

  render() {
    const timeNow = Date.now();

    return (
      <Host hidden={
        this._showFromDate && timeNow <= this._showFromDate.getTime()
        || this._hideFromDate && timeNow >= this._hideFromDate.getTime()
        || this.closedByCookie
      }>
        <slot></slot>
      </Host>
    );
  }
}
